import React from 'react';
import { useQuery } from '@apollo/client';

type result = {
  loading: boolean;
  dietSettingsData?: any;
};

interface IDietSettingsConnectorApolloProps {
  children: (result: result) => React.ReactElement;
  query: any;
}

export const DietSettingsConnectorApollo: React.FC<IDietSettingsConnectorApolloProps> = ({
  children,
  query,
}) => {
  const { loading, data, error } = useQuery(query);

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.dietSettingsData = data;
  }

  return children(result);
};

export default DietSettingsConnectorApollo;
